import React from 'react';

export const TextoDados = ({ chave, valor }) => (
	<div className="textData">
		<strong className="title">{chave}</strong>
		<div className="wrapper-edit">
			{ valor }
		</div>
	</div>
)